var map = {
	"./Carrefour.svg": 6724,
	"./FarmaVázquez.svg": 8920,
	"./Farmacia Morlan.svg": 8,
	"./Primor.svg": 1304,
	"./Welnia.svg": 459,
	"./dosfarma.svg": 255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6779;